export const Types = {
  updateStoreEdit: 'store/UPDATE_STORE_EDIT',
  getStore: 'store/GET_STORE',
  updateStore: 'store/UPDATE_STORE',
  updateStores: 'store/UPDATE_STORES',
  setStoreData: 'store/SET_STORE_DATA',
  updateStoreData: 'store/UPDATE_STORE_DATA',
  setStorePRMSupply: 'store/SET_STORE_PRM_SUPPLY',
  updateStorePRMSupply: 'store/UPDATE_STORE_PRM_SUPPLY',
  getStoreAvailableDates: 'store/GET_STORE_AVAILABLE_DATES',
  updateGetStoreAvailableDates: 'store/UPDATE_GET_STORE_AVAILABLE_DATES',
  setStoreAvailableDates: 'store/SET_STORE_AVAILABLE_DATES',
  updateSetStoreAvailableDates: 'store/UPDATE_SET_STORE_AVAILABLE_DATES',
  setStoreAvailableTimes: 'store/SET_STORE_AVAILABLE_TIMES',
  updateStoreAvailableTimes: 'store/UPDATE_STORE_AVAILABLE_TIMES',
  updateStoreAvailableTimesEdit: 'store/UPDATE_STORE_AVAILABLE_TIMES_EDIT',
  setCheckin: 'store/SET_CHECKIN',
  updateCheckin: 'store/UPDATE_CHECKIN',
  getAdjustSupply: 'store/GET_ADJUST_SUPPLY',
  updateAdjustSupply: 'store/UPDATE_ADJUST_SUPPLY',
  getTransferStock: 'stores/GET_TRANSFER_STOCK',
  updateTransferStock: 'stores/UPDATE_TRANSFER_STOCK',
  getDestinyStores: 'stores/GET_DESTINY_STORES',
  updateDestinyStores: 'stores/UPDATE_DESTINY_STORES',
  getStoreHistory: 'store/GET_STORE_HISTORY',
  updateStoreHistory: 'store/UPDATE_STORE_HISTORY',
  setZipCodeData: 'store/SET_ZIP_CODE',
  updateZipCodeData: 'store/UPDATE_ZIP_CODE',
  reset: 'store/RESET'
}

export function updateStoreEdit ({ storeEdit = {} } = {}) {
  return {
    type: Types.updateStoreEdit,
    payload: { storeEdit }
  }
}

export function getStore ({ storeId, campaignId } = {}) {
  return {
    type: Types.getStore,
    payload: { storeId, campaignId }
  }
}

export function updateStore ({ store = {} } = {}) {
  return {
    type: Types.updateStore,
    payload: { store }
  }
}

export function updateStores ({ stores = [] } = {}) {
  return {
    type: Types.updateStores,
    payload: { stores }
  }
}

export function setStoreData ({ campaignId, storeId, data, redirect = false } = {}) {
  return {
    type: Types.setStoreData,
    payload: { campaignId, storeId, data, redirect }
  }
}

export function updateStoreData ({ data = {}, error, respondedData, redirect } = {}) {
  return {
    type: Types.updateStoreData,
    payload: { data, error, respondedData, redirect }
  }
}

export function setStorePRMSupply ({ campaignId, storeId, supply, supplyObs, whatsappRedeemedSupply = '' } = {}) {
  return {
    type: Types.setStorePRMSupply,
    payload: { campaignId, storeId, supply, supplyObs, whatsappRedeemedSupply }
  }
}

export function setZipCodeData ({ zipcode } = {}) {
  return {
    type: Types.setZipCodeData,
    payload: { zipcode }
  }
}

export function updateZipCodeData ({ data = {}, error } = {}) {
  return {
    type: Types.updateZipCodeData,
    payload: { data, error }
  }
}

export function updateStorePRMSupply ({ data = {}, error } = {}) {
  return {
    type: Types.updateStorePRMSupply,
    payload: { data, error }
  }
}

export function getStoreAvailableDates ({ campaignId, storeId } = {}) {
  return {
    type: Types.getStoreAvailableDates,
    payload: { campaignId, storeId }
  }
}

export function updateGetStoreAvailableDates ({ respondedAvailableDates, availableDates, availableTimes, opensIn, error } = {}) {
  return {
    type: Types.updateGetStoreAvailableDates,
    payload: { respondedAvailableDates, availableDates, availableTimes, opensIn, error }
  }
}

export function setStoreAvailableDates ({ campaignId, storeId, dates } = {}) {
  return {
    type: Types.setStoreAvailableDates,
    payload: { campaignId, storeId, dates }
  }
}

export function updateSetStoreAvailableDates ({ respondedAvailableDates, availableDates, availableTimes, error } = {}) {
  return {
    type: Types.updateSetStoreAvailableDates,
    payload: { respondedAvailableDates, availableDates, availableTimes, error }
  }
}

export function setStoreAvailableTimes ({ campaignId, storeId, times } = {}) {
  return {
    type: Types.setStoreAvailableTimes,
    payload: { campaignId, storeId, times }
  }
}

export function updateStoreAvailableTimes ({ respondedAvailableTimes, error } = {}) {
  return {
    type: Types.updateStoreAvailableTimes,
    payload: { respondedAvailableTimes, error }
  }
}

export function updateStoreAvailableTimesEdit ({ times = [] } = {}) {
  return {
    type: Types.updateStoreAvailableTimesEdit,
    payload: { times }
  }
}

export function setCheckin ({ campaignId, storeId } = {}) {
  return {
    type: Types.setCheckin,
    payload: { campaignId, storeId }
  }
}

export function updateCheckin ({ respondedCheckin, error } = {}) {
  return {
    type: Types.updateCheckin,
    payload: { respondedCheckin, error }
  }
}

export function getAdjustSupply ({ campaignId, storeId, reason, supply, informations } = {}) {
  return {
    type: Types.getAdjustSupply,
    payload: { campaignId, storeId, reason, supply, informations }
  }
}

export function updateAdjustSupply ({ supply = {}, error } = {}) {
  return {
    type: Types.updateAdjustSupply,
    payload: { supply, error }
  }
}

export function getTransferStock ({ campaignId, originStore, destinyStore, reason, stockToTransfer, informations } = {}) {
  return {
    type: Types.getTransferStock,
    payload: { campaignId, originStore, destinyStore, reason, stockToTransfer, informations }
  }
}

export function updateTransferStock ({ stock = {}, error } = {}) {
  return {
    type: Types.updateTransferStock,
    payload: { stock, error }
  }
}

export function getDestinyStores ({ campaignId, storeId, project, allStoresFromSameCp } = {}) {
  return {
    type: Types.getDestinyStores,
    payload: { campaignId, storeId, project, allStoresFromSameCp }
  }
}

export function updateDestinyStores ({ store = {}, error } = {}) {
  return {
    type: Types.updateDestinyStores,
    payload: { store, error }
  }
}

export function getStoreHistory ({ campaignId, storeId, project } = {}) {
  return {
    type: Types.getStoreHistory,
    payload: { campaignId, storeId, project }
  }
}

export function updateStoreHistory ({ store = {}, error } = {}) {
  return {
    type: Types.updateStoreHistory,
    payload: { store, error }
  }
}

export function reset () {
  return {
    type: Types.reset
  }
}
